<template>
  <div class="px-4 py-2">
    <!-- Breadcrumbs -->
    <app-breadcrumbs :items="breadcrumbItems" />

    <!-- Cabeçalho -->
    <div class="d-flex justify-space-between align-center my-4">
      <h1 class="font-weight-bold" style="font-size: 18px">Cotações</h1>
    </div>

    <!-- Barra de Ferramentas da Tabela -->
    <div class="d-flex align-center pb-4">
      <v-text-field
        v-model="search"
        placeholder="Buscar por ID ou título"
        outlined
        dense
        prepend-inner-icon="mdi-magnify"
        clearable
        hide-details
        style="max-width: 500px;"
      />
      <div class="d-flex align-center gap-2">
        <div class="text-center">
          <v-menu
            v-model="listFilter"
            :close-on-content-click="false"
            :nudge-width="250"
            offset-y
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                text
                color="primary"
                class="ml-4">
                  Filtros
                <v-icon right>mdi-filter</v-icon>
              </v-btn>
            </template>

            <v-card>
              <v-list dense>
                <v-list-item>
                  <v-select
                    v-model="filters.status"
                    :items="status"
                    small-chips
                    label="Status da cotação"
                    outlined
                    clearable
                    dense
                    item-value="nome_status"
                    item-text="nome_status"
                  />
                </v-list-item>
                <v-list-item>
                  <AppRangeDate v-model="selectedPeriod" />
                </v-list-item>
                <v-list-item>
                  <v-select
                    v-model="filters.empresa"
                    :items="filiais"
                    small-chips
                    label="Empresa"
                    outlined
                    clearable
                    dense
                    item-value="idfilial"
                    :item-text="item => item.razao_social || item.nome_fantasia"
                  />
                </v-list-item>
                <v-list-item>
                  <v-select
                    v-model="filters.fornecedor"
                    :items="fornecedores"
                    small-chips
                    label="Fornecedor"
                    outlined
                    clearable
                    dense
                    item-value="id"
                    item-text="razao_social"
                  />
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </div>

        <div>
          <v-btn
            @click="getCotacoesMarket()"
            color="primary"
            class="ml-4">
            Carregar dados
            <v-icon right>mdi-reload</v-icon>
          </v-btn>
        </div>
      </div>
    </div>

    <div class="active-filters mt-3 mb-3" v-if="activeFilters.length">
      <v-btn outlined x-small color="primary" class="text-capitalize mr-3 clear-filters-btn" @click="clearFilters">
        <v-icon small left>mdi-broom</v-icon>
        Limpar filtros
      </v-btn>
      <v-chip
        v-for="filter in activeFilters"
        :key="filter.key"
        close
        small
        class="mr-2 filter-chip"
        @click:close="removeFilter(filter.key)"
      >
        {{ filter.label }}: {{ filter.value }}
      </v-chip>
    </div>

    <!-- Carrossel de Cards de Informações -->
    <div class="carousel-section mb-2" v-if="carouselCards.length > 0">
      <h3 class="text-subtitle-1 font-weight-medium mb-2">Minhas pendências</h3>

      <div class="carousel-container">
        <v-btn
          icon
          small
          class="carousel-nav-btn carousel-nav-left"
          @click="scrollCarousel('left')"
          :disabled="carouselScrollLeft <= 0"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>

        <div class="carousel-wrapper" ref="carouselWrapper" @scroll="updateScrollPosition">
          <v-card
            v-for="card in carouselCards"
            :key="card.cotacao_transacao_id"
            class="carousel-card"
            outlined
          >
            <v-card-text class="pa-3">
              <div class="d-flex justify-space-between align-start mb-1">
                <div>
                  <div class="text-h6 font-weight-bold">#{{ card.cotacao_transacao_id }}</div>
                  <div class="text-caption grey--text">{{ card.cotacao_titulo }}</div>
                </div>
                <app-badge rounded
                  :color="getStatusColor(card.nome_status)"
                  class="ml-2"
                >
                  {{ card.nome_status }}
                </app-badge>
              </div>

              <div class="card-info-row">
                <span class="text-caption grey--text">{{ itensSemPropostaCardText(card) }}</span>
              </div>
              <div class="card-info-row">
                <span class="text-caption grey--text">{{ card.fornecedores }} fornecedores convidados</span>
              </div>
              <div class="card-info-row mb-3">
                <span
                  v-if="metricasFornecedoresCard(card)"
                  class="text-caption grey--text"
                >
                  {{ metricasFornecedoresCard(card).responderam }} / {{ metricasFornecedoresCard(card).total }} propostas recebidas
                </span>
                <span v-else class="text-caption grey--text">—</span>
              </div>

              <div class="d-flex gap-2">
                <v-btn
                  x-small
                  text
                  color="primary"
                  class="text-capitalize"
                  @click="() => {
                    openDetalhesCotacao.isOpen = true
                    openDetalhesCotacao.idCotacao = card.cotacao_transacao_id
                  }"
                >
                  Ver detalhes
                </v-btn>
              </div>
            </v-card-text>
          </v-card>
        </div>

        <v-btn
          icon
          small
          class="carousel-nav-btn carousel-nav-right"
          @click="scrollCarousel('right')"
          :disabled="carouselScrollLeft >= carouselMaxScroll"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
      </div>
    </div>

    <v-card>
      <!-- Abas de Filtro -->
      <v-tabs v-model="tab" background-color="transparent">
        <v-tab v-for="item in tabs" :key="item.key">{{ item.name }}</v-tab>
      </v-tabs>

      <div v-if="filteredCotacoes.length === 0" class="d-flex flex-column align-center justify-center text-center py-70px" style="height: 100%;">
        <v-icon size="64" color="#e0e0e0" class="mb-4">mdi-shopping</v-icon>
        <div class="text-body-1 font-weight-medium mb-1" style="color: #424242;">
          {{ getEmptyStateMessage() }}
        </div>
      </div>

      <!-- Tabela de Cotações -->
      <v-data-table
        v-else
        v-model="selected"
        :headers="headers"
        :items="filteredCotacoes"
        item-key="cotacao_transacao_id"
        show-select
        :height="tableHeight"
        fixed-header
        :loading="isLoading"
        hide-default-footer
        disable-pagination
        class="fixed-columns-table"
      >
        <template v-slot:item.cotacao_transacao_id="{ item }">
          <div>
            <span class="font-weight-bold">#{{ item.cotacao_transacao_id }}</span>
            <div class="text-caption grey--text">{{ item.cotacao_titulo }}</div>
          </div>
        </template>

        <template v-slot:item.nome_status="{ item }">
          <app-badge rounded :color="getStatusColor(item.nome_status)">
            <span :class="getStatusIcon(item.nome_status)" class="mr-1 text-sm-body-1"></span>
            {{ item.nome_status }}
          </app-badge>
        </template>

        <template v-slot:item.empresa="{ item }">
          <div>
            <span>{{ item.razao_social }}</span>
            <div class="text-caption grey--text">Filial {{ item.idfilial }}</div>
          </div>
        </template>

        <template v-slot:item.nome_completo="{ item }">
          <div>
            {{ item.nome_completo }}
          </div>
        </template>

        <template v-slot:item.inicio_periodo_recebimento_proposta="{ item }">
          <div>
            {{ item.inicio_periodo_recebimento_proposta }} - {{ item.termino_periodo_recebimento_proposta }}
          </div>
        </template>

        <template v-slot:item.qtd_produtos="{ item }">
          <div>
            {{ item.qtd_produtos }}
          </div>
        </template>

        <template v-slot:item.fornecedores="{ item }">
          <div>
            {{ item.fornecedores }} convidados
          </div>
        </template>

        <template v-slot:item.propostas_recebidas="{ item }">
          <div v-if="item._original && item._original.resumo && item._original.resumo.metricas && item._original.resumo.metricas.fornecedores">
            {{ item._original.resumo.metricas.fornecedores.responderam }} / {{ item._original.resumo.metricas.fornecedores.total }}
          </div>
          <div v-else>-</div>
        </template>

        <template v-slot:item.nome_decisao="{ item }">
          <app-badge rounded :color="getDecisaoColor(item.nome_decisao)">
            {{ item.nome_decisao }}
          </app-badge>
        </template>

        <template v-slot:item.nome_situacao_pedidos="{ item }">
          <app-badge rounded :color="getSituacaoColor(item.nome_situacao_pedidos)">
            {{ item.nome_situacao_pedidos }}
          </app-badge>
        </template>

        <template v-slot:item.updated_at="{ item }">
          <div>
            {{ item.updated_at }}
          </div>
        </template>

        <template v-slot:item.actions="{ item }">
          <div class="d-flex justify-end align-center">

            <v-btn v-if="item.nome_status === 'Rascunho'"
                small
                text
                color="primary"
                class="text-capitalize"
                @click="() => {
                  openEditCotacao.isOpen = true
                  openEditCotacao.idCotacao = item.cotacao_transacao_id
                }">
              Editar cotação
            </v-btn>

            <v-btn v-else-if="item.nome_status === 'Prazo encerrado'"
               small
               text
               color="primary"
               class="text-capitalize"
               @click="() => {
                openDetalhesCotacao.isOpen = true
                openDetalhesCotacao.idCotacao = item.cotacao_transacao_id
              }">
              Ver propostas
            </v-btn>

            <v-btn v-else
                small
                text
                color="primary"
                class="text-capitalize"
                @click="() => {
                  openDetalhesCotacao.isOpen = true
                  openDetalhesCotacao.idCotacao = item.cotacao_transacao_id
                }">
              Ver detalhes
            </v-btn>

            <div class="ml-2">
              <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                      icon
                      small
                      v-bind="attrs"
                      v-on="on"
                  >
                    <span class="mdi mdi-dots-vertical text-sm-body-1"></span>
                  </v-btn>
                </template>

                <v-list dense>
                  <v-list-item @click="() => {
                    openDetalhesCotacao.isOpen = true
                    openDetalhesCotacao.idCotacao = item.cotacao_transacao_id
                  }">
                    <v-list-item-title>Visualizar Detalhes</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.nome_status !== 'Cancelada' && item.nome_status !== 'Rascunho' && item.nome_status !== 'Concluída'" @click="cancelItem(item)">
                    <v-list-item-title>Cancelar</v-list-item-title>
                  </v-list-item>
                  <v-list-item v-if="item.nome_status === 'Rascunho'" @click="deleteItem(item)">
                    <v-list-item-title>Excluir</v-list-item-title>
                  </v-list-item>
                </v-list>

              </v-menu>
            </div>
          </div>
        </template>

        <!-- Infinite Scroll Trigger -->
        <template v-slot:body.append>
          <div v-if="scrollInfo.has_more" v-intersect="loadNextPage" class="d-flex justify-center py-4">
            <v-progress-circular
                v-if="scrollInfo.loading"
                indeterminate
                color="primary"
                size="24"
            ></v-progress-circular>
          </div>
        </template>
      </v-data-table>

      <div class="d-flex justify-end align-center px-4 py-3 text-caption border-t-gray-400">
        Total de itens: {{ scrollInfo.total }}
      </div>
    </v-card>

    <NovaCotacaoDialog
      :visible="openEditCotacao.isOpen"
      :id-cotacao="openEditCotacao.idCotacao"
      :handleClose="
      () => {
        openEditCotacao.isOpen = false;
        getCotacoes();
      }
      "
    />

    <DetalhesCotacaoDialog
      :visible="openDetalhesCotacao.isOpen"
      :id-cotacao="openDetalhesCotacao.idCotacao"
      :handleClose="
      () => {
        openDetalhesCotacao.isOpen = false;
        getCotacoesMarket();
      }
      "
      :handleEdit="
      (idCotacao) => {
        openEditCotacao.isOpen = true;
        openEditCotacao.idCotacao = idCotacao;
        openDetalhesCotacao.isOpen = false;
      }
      "
    />
  </div>
</template>

<script setup>
import AppBadge from "@/components/utils/ui_v4/feedback/AppBadge.vue";
import AppRangeDate from "@/components/utils/ui_v4/forms/AppRangeDate.vue";
import AppBreadcrumbs from "@/components/utils/ui_v4/navigations/AppBreadcrumbs.vue";
import DetalhesCotacaoDialog from "@/components/webcotacao/components/DetalhesCotacaoDialog.vue";
import NovaCotacaoDialog from "@/components/webcotacao/components/NovaCotacaoDialog.vue";
import useCotacoesList from "@/components/webcotacao/composables/useCotacoesList";

const breadcrumbItems = [
  { title: 'Cotação', onClick: () => {} },
  { title: 'Lista de Cotações', active: true, badgeColor: 'blue' }
];

const cotacoesList = useCotacoesList();

const {
  tab,
  search,
  selected,
  isLoading,
  listFilter,
  tableHeight,
  selectedPeriod,
  filters,
  status,
  filiais,
  fornecedores,
  tabs,
  headers,
  filteredCotacoes,
  carouselCards,
  carouselWrapper,
  carouselScrollLeft,
  carouselMaxScroll,
  scrollCarousel,
  updateScrollPosition,
  getStatusColor,
  getStatusIcon,
  getDecisaoColor,
  getSituacaoColor,
  deleteItem,
  scrollInfo,
  loadNextPage,
  getEmptyStateMessage,
  openEditCotacao,
  openDetalhesCotacao,
  getCotacoes,
  activeFilters,
  removeFilter,
  clearFilters,
  getCotacoesMarket
} = cotacoesList;

const cancelItem = (item) => cotacoesList.cancelItem && cotacoesList.cancelItem(item);

function metricasFornecedoresCard(card) {
  if (!card || !card._original || !card._original.resumo || !card._original.resumo.metricas) {
    return null;
  }
  const m = card._original.resumo.metricas.fornecedores;
  if (!m) return null;
  const total = m.total != null ? m.total : card.fornecedores;
  const responderam = m.responderam != null ? m.responderam : 0;
  if (total == null) return null;
  return { responderam, total };
}

function itensSemPropostaCardText(card) {
  var metricas = card && card._original && card._original.resumo && card._original.resumo.metricas;
  var itens = metricas && metricas.itens_nesta_cotacao;
  if (itens && itens.itens_sem_proposta != null) {
    return itens.itens_sem_proposta + ' itens sem proposta';
  }
  if (card && card.qtd_produtos != null) {
    return card.qtd_produtos + ' itens na cotação';
  }
  return '—';
}
</script>

<style scoped>
/* Carousel Styles */
.carousel-section {
  position: relative;
}

.carousel-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 12px;
}

.carousel-wrapper {
  display: flex;
  gap: 16px;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 4px;
  flex: 1;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE and Edge */
}

.carousel-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.carousel-card {
  min-width: 300px;
  max-width: 300px;
  flex-shrink: 0;
  transition: transform 0.2s, box-shadow 0.2s;
  border: 1px solid #e0e0e0 !important;
}

.carousel-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1) !important;
}

.carousel-nav-btn {
  background: white !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  z-index: 2;
}

.carousel-nav-btn:disabled {
  opacity: 0.3;
}

.card-info-row {
  margin-bottom: 4px;
}

.gap-2 {
  gap: 8px;
}

.v-text-field__details {
  height: 1px !important;
}

.filter-chip {
  background: #FAFAFA !important;
  border: 1px solid #F3F8FF !important;
  border-radius: 4px !important;
  color: #1976d2 !important;
  padding: 3px 10px !important;
  min-height: auto !important;
  height: auto !important;
}

.clear-filters-btn {
  font-size: 0.75rem;
  padding: 12px 8px !important;
  min-width: auto;
  height: auto;
}

/* Fixar a coluna de seleção (checkbox) à esquerda */
:deep(.fixed-columns-table .v-data-table__wrapper) {
  overflow-x: auto !important;
}

:deep(.fixed-columns-table thead th:first-child),
:deep(.fixed-columns-table tbody td:first-child) {
  position: sticky !important;
  left: 0 !important;
  z-index: 3 !important;
  background: white !important;
  border-right: 1px solid rgba(0, 0, 0, 0.12) !important;
  width: 80px;
}

/* Fixar a coluna de ações à direita */
:deep(.fixed-columns-table thead th:last-child),
:deep(.fixed-columns-table tbody td:last-child) {
  position: sticky !important;
  right: 0 !important;
  z-index: 3 !important;
  background: white !important;
  border-left: 1px solid rgba(0, 0, 0, 0.12) !important;
  width: 80px;
}

/* Garantir que o cabeçalho tenha z-index maior */
:deep(.fixed-columns-table thead th) {
  z-index: 4 !important;
}

:deep(.fixed-columns-table thead th:first-child) {
  z-index: 5 !important;
}

:deep(.fixed-columns-table thead th:last-child) {
  z-index: 5 !important;
}

/* Customizar cor dos checkboxes para primary */
:deep(.fixed-columns-table .v-data-table__checkbox .v-icon) {
  color: #2b81d5 !important;
}

:deep(.fixed-columns-table .v-simple-checkbox .v-icon) {
  color: #2b81d5 !important;
}

/* Checkbox não selecionado */
:deep(.fixed-columns-table .v-simple-checkbox:not(.v-simple-checkbox--disabled) .mdi-checkbox-blank-outline) {
  color: rgba(0, 0, 0, 0.54) !important;
}

/* Checkbox selecionado */
:deep(.fixed-columns-table .v-simple-checkbox .mdi-checkbox-marked) {
  color: #2b81d5 !important;
}

/* Checkbox indeterminado */
:deep(.fixed-columns-table .v-simple-checkbox .mdi-minus-box) {
  color: #2b81d5 !important;
}
</style>
